import {combineReducers} from "redux";

import power from "../features/admin/powerprogress/powerprogress/Slice";


const powerprogress = combineReducers({
    power,
  
});

export default powerprogress;